import mqtt from "mqtt";
const client = mqtt.connect("wss://mqtt.db2sg.com:9001/mqtt");

client.on("connect", (err) => {
  console.log(err);
});
export { client };
